import { registerMutation, registerQuery } from 'data-fetching-client';
import { fetchUserDismissedYearInReviews, updateUserDismissedYearInReviews } from '../apis/userAttributes';
export const FETCH_HAS_DISMISSED_YEAR_IN_REVIEW_REQUEST = registerQuery({
  fieldName: 'dismissedYearInReviewsUserSetting',
  fetcher() {
    return fetchUserDismissedYearInReviews().then(response => JSON.parse(response)).catch(() => ({}));
  }
});
export const UPDATE_HAS_DISMISSED_YEAR_IN_REVIEW_REQUEST = registerMutation({
  fieldName: 'dismissedYearInReviewsUserSetting',
  args: ['value'],
  fetcher({
    value
  }) {
    return updateUserDismissedYearInReviews(value);
  }
});